import { FC } from "react";
import { IconType } from "../icons/types";

type IconProps = {
  width?: number;
  height?: number;
  id?: string;
};

export const RollinSmallLogo: FC<IconType & IconProps> = ({
  width = 24,
  height = 32,
  id,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.184 15.2627C23.2985 19.6363 22.8821 23.9203 19.1758 25.6836C16.0942 27.1481 6.67247 27.5965 3.43471 24.6475C-0.365225 21.1805 0.75914 12.0249 1.82104 9.62388C3.04951 6.85427 5.13167 5.24033 12.0965 5.17059C20.4043 5.17059 22.9966 7.53173 23.184 15.2627ZM14.4181 9.325H6.52671C6.4122 15.1432 6.47466 19.3374 6.55795 22.6749H11.045C11.0242 21.3997 11.0138 20.1345 11.0034 18.8592H11.982C12.9233 20.8191 13.1246 21.2153 13.8521 22.647L13.8663 22.6749H18.8114C17.8016 20.9813 17.229 19.9452 16.3753 18.3711C16.3909 18.3626 16.4065 18.3541 16.422 18.3456C16.6981 18.1951 16.9761 18.0436 17.2915 17.7135C18.6136 16.3487 19.2799 11.995 16.9271 10.1619C16.3337 9.70359 15.657 9.325 14.4181 9.325Z"
      fill="#FF00AA"
    />
    <path
      d="M11.732 15.3623C11.0553 15.9999 10.2849 15.721 10.1391 15.6612C8.57752 14.9937 8.96272 12.5329 12.086 11.3772C12.1068 11.3772 14.8656 12.3735 14.9073 14.2863C14.9281 15.5018 13.4394 16.3486 12.4087 15.3623C12.6408 16.2218 12.8338 16.4354 12.9023 16.5112C12.9045 16.5136 12.9065 16.5158 12.9084 16.518H11.2427C11.2446 16.5159 11.2466 16.5136 11.2487 16.5113C11.3171 16.4356 11.5098 16.2223 11.732 15.3623Z"
      fill="#FF00AA"
    />
    <path
      d="M12.0755 3.82565C17.2393 3.82565 22.0907 2.67995 22.0907 0H2.06036C2.06036 2.67995 6.91179 3.82565 12.0755 3.82565Z"
      fill={`url(#${id}_top)`}
    />
    <path
      d="M12.0755 28.1744C6.91179 28.1744 2.06036 29.3201 2.06036 32H22.0907C22.0907 29.3201 17.2393 28.1744 12.0755 28.1744Z"
      fill={`url(#${id}_bottom)`}
    />
    <defs>
      <linearGradient
        id={`${id}_top`}
        x1="10.8791"
        y1="32"
        x2="10.8791"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00DBFF" stopOpacity="0" />
        <stop offset="0.16" stopColor="#00DBFF" />
        <stop offset="0.83" stopColor="#00DBFF" />
        <stop offset="1" stopColor="#00DBFF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id={`${id}_bottom`}
        x1="10.8791"
        y1="32"
        x2="10.8791"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00DBFF" stopOpacity="0" />
        <stop offset="0.16" stopColor="#00DBFF" />
        <stop offset="0.83" stopColor="#00DBFF" />
        <stop offset="1" stopColor="#00DBFF" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
